export function isElementInViewport(el: Element | string): boolean {
  const element = typeof el === "string" ? document.querySelector(el) : el;

  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= windowHeight &&
    rect.right <= windowWidth
  );
}
